import React from 'react';
import classNames from 'classnames';
import Markdown from 'react-remarkable';
import {trans} from './utils';
import ExtraInfo from './ExtraInfo';
import ExtraInfoSchedule from './ExtraInfoSchedule';


export default class Legend extends React.Component {

  constructor (props) {
    super(props);
    this.prevPage = this.prevPage.bind(this);
    this.nextPage = this.nextPage.bind(this);
    this.pageSize = window.LANDSCAPE ? 11 : 8;
  }

  render () {
    let {poi, subcategories, legend_type, lang, selected} = this.props;

    let items = [];

    const pageSize = this.pageSize,
          page = this.props.page;

    let totalPages = Math.ceil(poi.length / pageSize);
    if (legend_type === 'subcategory') {
        totalPages = Math.ceil(subcategories.length / pageSize);
    }

    if (legend_type === 'detailed' || legend_type === 'extra') {
      for (let i=page*pageSize; i < Math.min((page+1)*pageSize, poi.length); i++) {
        let p = poi[i],
            isSelected = selected.poi != null && p.poi_id === selected.poi.poi_id;

        items.push(<DetailedLegendItem poi={p} key={p.poi_id} lang={lang}
                onClick={this.props.selectPOI} number={i+1}
                selected={isSelected} />);
      }
    } else if (legend_type === 'subcategory') {
      items = subcategories.map(cat => {
        let isSelected = (selected.subcategory != null &&
          selected.subcategory.poi_subcategory_id === cat.poi_subcategory_id);

        return <SubcatLegendItem
                   key={cat.poi_subcategory_id} subcategory={cat}
                   selected={isSelected}
                   lang={lang} onClick={this.props.selectSubcategory} />;
      });
    }

    let style = {
      flexBasis: this.props.info_height,
    }

    let itemsStyle = {};

    if (legend_type === 'subcategory' && subcategories.length <= 12) {
      itemsStyle['height'] = 80 * Math.ceil(subcategories.length / 2);
    }

    if (legend_type === 'detailed' && poi.length <= 12) {
      itemsStyle['height'] = 80 * Math.ceil(poi.length / 2);
    }

    let extraPanel = null;

    if (legend_type === 'extra') {
      if (selected.poi == null) {
        extraPanel = (
          <div className="ExtraInfo">
            <Markdown source={trans(lang, this.props.extra_info)} />
          </div>
        );
      } else {
        if (Array.isArray(selected.poi.extra)) {
          extraPanel = <ExtraInfoSchedule
                          key={selected.poi.poi_id}
                          poi={selected.poi} lang={lang} />;
        } else {
          extraPanel = <ExtraInfo
                          key={selected.poi.poi_id}
                          poi={selected.poi} lang={lang} />;
        }
      }
    }

    return (
      <div className={`Legend Legend--${legend_type}`} style={style}>
        <div className="legendWrapper">
          <div className="header">
            <h2>{ trans(lang, this.props.legend_title) }</h2>
            <p className="pages"
               style={{display: totalPages <= 1 ? 'none' : 'block'}}>
              <span className="prev" onClick={this.prevPage}>
                <svg viewBox="0 0 50 50">
                  <path fill="#9A9A9A" d="M38.208,48.376c1.826-1.825,1.826-4.784,0-6.609L21.442,24.999L38.208,8.232c1.826-1.825,1.826-4.784,0-6.609c-1.825-1.824-4.783-1.824-6.607,0L11.774,21.45c-0.977,0.976-1.413,2.274-1.345,3.552 c-0.066,1.277,0.37,2.574,1.345,3.548l19.827,19.825C33.425,50.201,36.383,50.201,38.208,48.376z" />
                </svg>
              </span>
              <span className="counter">{ `${page + 1} / ${ totalPages }` }</span>
              <span className="next" onClick={this.nextPage}>
                <svg viewBox="0 0 50 50">
                  <path fill="#9A9A9A" d="M11.792,48.376c-1.826-1.825-1.826-4.784,0-6.609l16.767-16.768L11.792,8.232 c-1.826-1.825-1.826-4.784,0-6.609c1.825-1.824,4.783-1.824,6.607,0L38.227,21.45c0.977,0.976,1.412,2.274,1.344,3.552 c0.066,1.277-0.369,2.574-1.344,3.548L18.399,48.376C16.575,50.201,13.617,50.201,11.792,48.376z"/>
                </svg>
              </span>
            </p>
          </div>
          <div className="items" style={itemsStyle}>
            { items }
          </div>
        </div>

        { extraPanel }
      </div>
    );
  }

  nextPage () {
    let totalPages = Math.ceil(this.props.poi.length / this.pageSize);
    this.props.setPage((this.props.page+1) % totalPages);

    window.TRACKING_EVENT.event = 'page_next';
    window.TRACKING_EVENT.source = 'legend';
  }

  prevPage () {
    let totalPages = Math.ceil(this.props.poi.length / this.pageSize);
    this.props.setPage((totalPages+this.props.page-1) % totalPages);

    window.TRACKING_EVENT.event = 'page_prev';
    window.TRACKING_EVENT.source = 'legend';
  }
}


class DetailedLegendItem extends React.Component {

  constructor (props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  render () {
    let {poi, lang} = this.props;

    let cls = classNames({
      DetailedLegendItem: true,
      selected: this.props.selected,
    });

    return (
      <div className={cls} onClick={this.handleClick}>
        <span className="number">{ this.props.number }</span>
        <h3>{ trans(lang, poi.name) }</h3>
        <span className="description">{ poi.address }</span>
      </div>
    );
  }

  handleClick () {
    if (this.props.onClick) this.props.onClick(this.props.poi);
    window.TRACKING_EVENT.event = 'poi';
    window.TRACKING_EVENT.source = 'legend';
    window.TRACKING_EVENT.target_id = this.props.poi.poi_id;
  }
}


class SubcatLegendItem extends React.Component {

  constructor (props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  render () {
    let {subcategory, lang} = this.props;

    let css = {};
    if (subcategory.image) {
      let bg = subcategory.image;
      css['backgroundImage'] = `url(${bg})`;
    }

    let cls = classNames({
      SubcatLegendItem: true,
      selected: this.props.selected,
    });

    return (
      <div className={cls} style={css} onClick={this.handleClick}>
        <h3>{ trans(lang, subcategory.name) }</h3>
      </div>
    );
  }

  handleClick () {
    if (this.props.onClick) this.props.onClick(this.props.subcategory);
    window.TRACKING_EVENT.event = 'subcategory';
    window.TRACKING_EVENT.source = 'legend';
    window.TRACKING_EVENT.target_id = this.props.subcategory.poi_subcategory_id;
  }
}

